// Auto-generated at build time — do not edit
export const version = "0.28.0";
export const commitHash = "d07b86a3";
export const buildTime = "2026-11-02T20:50:53.924Z";
export const buildId = "d07b86a3-1793652653927";
